module.exports = __webpack_public_path__ + "1128ce3b07ddd1c60914683bd0f797bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/trickstrat/sportsLogo.png
// module id = 1096
// module chunks = 0